import {Box, Grid} from '@mui/material';
import {useModal} from 'common/hooks/useModal';
import Button from 'components/Button';
import Dialog from 'components/Dialog';
import {GridCentered} from 'components/GridCentered';
import {useFieldValueGetter} from 'components/hook-form/useFieldValueGetter';
import FormikCheckbox from 'components/inputs/FormikCheckbox';
import FormikNumberField from 'components/inputs/FormikNumberField';
import {LabelText} from 'components/inputs/LabelText';
import Panel from 'components/Panel';
import {get, trimEnd} from 'lodash';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import {SftpPasswordPoliciesNames} from 'types/diplomat/sftp/SftpPasswordPolicies';

const SetPasswordPoliciesForm = ({prefix}: Props) => {
   const {t} = useTranslation();

   const p = prefix ? `${trimEnd(prefix, '.')}.` : '';
   const getValue = useFieldValueGetter<any>();
   const _UPPERCASE_CHECK = getValue(p + SftpPasswordPoliciesNames._UPPERCASE_CHECK);
   const _LOWERCASE_CHECK = getValue(p + SftpPasswordPoliciesNames._LOWERCASE_CHECK);
   const _NUMERIC_CHECK = getValue(p + SftpPasswordPoliciesNames._NUMERIC_CHECK);
   const _SPECIAL_CHECK = getValue(p + SftpPasswordPoliciesNames._SPECIAL_CHECK);

   return (
      <Panel name={t('Password must:')}>
         <Grid container spacing={1}>
            <GridCentered item>
               <LabelText>{t('Contain at least')}</LabelText>
            </GridCentered>
            <Grid item xs={2}>
               <FormikNumberField min={1} name={p + SftpPasswordPoliciesNames.minNumChars} />
            </Grid>
            <GridCentered item>
               <LabelText>{t('total characters.')}</LabelText>
            </GridCentered>
         </Grid>
         <Grid container spacing={1}>
            <GridCentered item>
               <FormikCheckbox
                  label={t('Contain at least')}
                  name={p + SftpPasswordPoliciesNames._UPPERCASE_CHECK}
               />
            </GridCentered>
            <Grid item xs={2}>
               <FormikNumberField
                  min={1}
                  name={p + SftpPasswordPoliciesNames.minNumUpper}
                  disabled={!_UPPERCASE_CHECK}
               />
            </Grid>
            <GridCentered item>
               <LabelText>{t('upper-case characters.')}</LabelText>
            </GridCentered>
         </Grid>
         <Grid container spacing={1}>
            <GridCentered item>
               <FormikCheckbox
                  label={t('Contain at least')}
                  name={p + SftpPasswordPoliciesNames._LOWERCASE_CHECK}
               />
            </GridCentered>
            <Grid item xs={2}>
               <FormikNumberField
                  min={1}
                  name={p + SftpPasswordPoliciesNames.minNumLower}
                  disabled={!_LOWERCASE_CHECK}
               />
            </Grid>
            <GridCentered item>
               <LabelText>{t('lower-case characters.')}</LabelText>
            </GridCentered>
         </Grid>
         <Grid container spacing={1}>
            <GridCentered item>
               <FormikCheckbox
                  label={t('Contain at least')}
                  name={p + SftpPasswordPoliciesNames._NUMERIC_CHECK}
               />
            </GridCentered>
            <Grid item xs={2}>
               <FormikNumberField
                  min={1}
                  name={p + SftpPasswordPoliciesNames.minNumNumeric}
                  disabled={!_NUMERIC_CHECK}
               />
            </Grid>
            <GridCentered item>
               <LabelText>{t('numeric characters.')}</LabelText>
            </GridCentered>
         </Grid>
         <Grid container spacing={1}>
            <GridCentered item>
               <FormikCheckbox
                  label={t('Contain at least')}
                  name={p + SftpPasswordPoliciesNames._SPECIAL_CHECK}
               />
            </GridCentered>
            <Grid item xs={2}>
               <FormikNumberField
                  min={1}
                  name={p + SftpPasswordPoliciesNames.minNumSpecial}
                  disabled={!_SPECIAL_CHECK}
               />
            </Grid>
            <GridCentered item>
               <LabelText>{t('special characters.')}</LabelText>
            </GridCentered>
         </Grid>
         <Box marginLeft={4}>(!, @ ...)</Box>
         {/* <Grid container spacing={1}>
            <GridCentered item>
               <FormikCheckbox
                  label={t('Be updated at least every')}
                  name={p + SftpPasswordPoliciesNames._BE_UPDATED_EVERY_CHECK}
               />
            </GridCentered>
            <Grid item xs={2}>
               <FormikNumberField
                  min={1}
                  name={p + SftpPasswordPoliciesNames.passwordUpdateInterval}
                  disabled={!get(values, p + SftpPasswordPoliciesNames._BE_UPDATED_EVERY_CHECK)}
               />
            </Grid>
            <GridCentered item>
               <LabelText>{t('days.')}</LabelText>
            </GridCentered>
         </Grid> */}
      </Panel>
   );
};

type Props = {
   prefix?: string;
};
const SetPasswordPoliciesButton = memo(({prefix}: Props) => {
   const {t} = useTranslation();
   const {open, handleOpen, handleClose} = useModal();

   return (
      <>
         <Button onClick={handleOpen}>{t('Set Password Policies')}</Button>
         <Dialog open={open} header={t('SFTP Password Policies')} close={handleClose}>
            <SetPasswordPoliciesForm prefix={prefix} />
            <Grid container justifyContent="center">
               <Grid item>
                  <Button onClick={handleClose}>{t('Ok')}</Button>
               </Grid>
            </Grid>
         </Dialog>
      </>
   );
});

export default SetPasswordPoliciesButton;
